export const Svg = ({ src, size = 32 }: { src: string; size?: number }) => {
    return <svg data-src={src} height={size} width={size} viewBox={`0 0 ${size} ${size}`} />
}
